import React from 'react';
import { Users, Plus, Edit2, Trash2 } from 'lucide-react';
import clsx from 'clsx';
import { ProjectScoping } from '../../types';

interface TeamSectionProps {
    team: ProjectScoping['team'];
    isDark: boolean;
    canEdit: boolean;
    onAddMember: () => void;
    onEditMember: (idx: number) => void;
    onDeleteMember: (idx: number) => void;
}

export const TeamSection: React.FC<TeamSectionProps> = ({ team, isDark, canEdit, onAddMember, onEditMember, onDeleteMember }) => (
    <div className={clsx('p-4 rounded-lg border', isDark ? 'bg-slate-800 border-slate-700' : 'bg-white border-slate-200')}>
        <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
                <Users size={18} className="text-orange-500" />
                <h3 className={clsx('font-semibold', isDark ? 'text-white' : 'text-slate-800')}>3. Team (Cross-functional Members)</h3>
            </div>
            {canEdit && (
                <button onClick={onAddMember} className="p-1 hover:bg-slate-700 rounded" title="Add Team Member">
                    <Plus size={16} className="text-slate-400" />
                </button>
            )}
        </div>
        <div className="mb-3">
            <div className="text-sm font-medium text-slate-500 mb-1">Team Lead</div>
            <div className={clsx('text-sm', isDark ? 'text-white' : 'text-slate-800')}>{team.lead}</div>
        </div>
        <div className="text-sm font-medium text-slate-500 mb-2">Members</div>
        <div className="grid grid-cols-2 gap-3">
            {team.members.map((member, idx) => (
                <div key={idx} className={clsx('p-3 rounded border relative group', isDark ? 'border-slate-700 bg-slate-900/50' : 'border-slate-200 bg-slate-50')}>
                    <div className={clsx('font-medium text-sm', isDark ? 'text-white' : 'text-slate-800')}>{member.name}</div>
                    <div className="text-xs text-slate-500 mt-0.5">{member.role} • {member.department}</div>
                    <div className="text-xs text-purple-500 mt-1">⚡ {member.expertise}</div>
                    {canEdit && (
                        <div className="absolute top-2 right-2 hidden group-hover:flex gap-1">
                            <button onClick={() => onEditMember(idx)} className="p-1 hover:bg-slate-600 rounded"><Edit2 size={12} className="text-slate-400" /></button>
                            <button onClick={() => onDeleteMember(idx)} className="p-1 hover:bg-red-700 rounded"><Trash2 size={12} className="text-red-400" /></button>
                        </div>
                    )}
                </div>
            ))}
        </div>
    </div>
);
